import { Layout } from 'antd';
import React, { useDebugValue, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import FooterLayout from '../../components/footer';
import MainHeader from '../../components/mainHeader';
import { storeredirectPath } from '../../store/products/productsActions';
import AppHeader from './header';

interface Props {
    children: any,
    location: any
}

const conditionalPaths = ['/', '/contact', '/services', '/profile', '/login', '/forgotPassword']

const PrivateLayout = (props: Props) => {
    const { pathname } = props.location;
    let customClass = 'privateLayout';
    const isLogin = useSelector((state: any) => state.user.isLogin)

    if (conditionalPaths.indexOf(pathname) > -1) {
        customClass += ' vertical-scroll';

    }

    return (
        <>
            <Layout className={customClass}>
                <AppHeader pathName={pathname} />
                {/* <MainHeader pathName={pathname} /> */}
                {
                    props.children
                }
                <FooterLayout pathName={pathname} />
            </Layout >

        </>
    )
}

export default PrivateLayout;